import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = props => {
  const { className, id, disabled, text, selected, linkProps } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {text}
      </NamedLink>
    </div>
  );
};

/**
 * @typedef {Object} TabConfig
 * @property {string} text - The text to be rendered in the tab
 * @property {boolean} disabled - Whether the tab is disabled
 * @property {boolean} selected - Whether the tab is selected
 * @property {Object} linkProps - The props to be passed to the link component
 * @property {string} linkProps.name - The name of the link
 * @property {string} linkProps.params - The path params to be passed to the link component
 * @property {string} linkProps.to - The rest of the URL params neede
 */

/**
 * A component that renders a tab navigation.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.tabRootClassName] - Custom class that overrides the default class for the tab element
 * @param {Array<TabConfig>} props.tabs - The tabs to render
 * @returns {JSX.Element}
 */
const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;




  
      const [newTabs, setNewTabs] = useState(tabs)
    
    
      useEffect(() => {
        if (window?.Weglot) {
          // Iterate through categories and subcategories
          const categoryNames = newTabs.flatMap(category => [
            category.text,
          ]);
    
          window.Weglot.translate(
            {
              words: categoryNames.map(name => ({ t: 1, w: name })),
              languageTo: window.Weglot.getCurrentLang(), // Specify the target language (Dutch in this case)
            },
            function (data) {
              // Update the categories state with translated names
              const updatedCategories = newTabs.map((category,index) => {
                const translatedCategoryName = data[index];
               
                return { ...category, text: translatedCategoryName };
              });
    
              // Set the new state with translated values
              setNewTabs(updatedCategories);
              console.log("Translation response:", updatedCategories,data);
            }
          );
        }
      }, [tabs]);
  

  return (
    <nav className={classes}>
      {newTabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabClasses} {...tab} />;
      })}
    </nav>
  );
};

export default TabNav;
